
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[username]",
      function () {
        return require("private-next-pages/user/[username].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[username]"])
      });
    }
  